const isTruthy = (value) => value === true || value === "true";

export const canAccessProductVariations = (userTypeInfo) => {
  if (!userTypeInfo) return false;
  if (/promoter/i.test(userTypeInfo)) return false;
  if (userTypeInfo === "Admin") return false;
  return true;
};

const hasStartSellerEnabled = (userInfo) => {
  if (!userInfo) return false;
  const plan = (userInfo?.plan || userInfo?.subscriptionType || "").toString();
  return (
    isTruthy(userInfo?.showCase) || isTruthy(userInfo?.showcase) || /startseller|seller/i.test(plan)
  );
};

const useDashboardPermissions = (userTypeInfo, userInfo = null) => {
  const isManager = userTypeInfo === "Manager";
  const isPartner = userTypeInfo === "Partner";
  const isSeller = userTypeInfo === "Seller";
  const isStore = userTypeInfo === "Store";
  const isCustomer = userTypeInfo === "Customer";
  const isPromoter = /promoter/i.test(userTypeInfo);
  const storeSalesEnabled = isStore && hasStartSellerEnabled(userInfo);

  const hasSubscription = isManager || isPartner || isSeller || storeSalesEnabled;

  const hasMap = isManager || isPartner || isStore || isSeller;

  const canViewStorePanel = hasSubscription || isCustomer;
  const canManageProducts = !isStore || storeSalesEnabled;

  const canViewFeature = (feature) => {
    const featurePermissions = {
      storePanel: canViewStorePanel,
      storeTransactions: isStore || isManager,
      qrCodePay: isStore || isManager,
      networkDirects: isManager || isPartner || isStore,
      networkAll: isManager || isPartner || isStore,
      editProfile: true,
      walletStatement: true,
      extracoinStatement: true,
      extrabonusStatement: true,
      bonusStatement: true,
      dropshipping: false, // Banggood descontinuado
      coupons: true,
      products: true,
      attributes: canManageProducts,
      sales: true,
      purchases: true,
      extracoinTransfer: true,
      extracoinIntents: true,
      withdrawIntent: hasSubscription || isCustomer,
      extrapay: true,
      userStore: hasSubscription,
      favorites: true,
      importProducts: hasSubscription,
      renewSubscription: hasSubscription,
      web3Dashboard: true,
      storesMap: hasMap,
      fringeBenefit: true,
      evaluationButton: true,
      createProducts: canManageProducts,
      publishProducts: canManageProducts,
      storeUpgradeRequired: isStore && !storeSalesEnabled,
    };

    return featurePermissions[feature] ?? false;
  };

  const getAvailableFeatures = () => {
    return {
      storePanel: canViewFeature("storePanel"),
      storeTransactions: canViewFeature("storeTransactions"),
      qrCodePay: canViewFeature("qrCodePay"),
      networkDirects: canViewFeature("networkDirects"),
      networkAll: canViewFeature("networkAll"),
      editProfile: canViewFeature("editProfile"),
      walletStatement: canViewFeature("walletStatement"),
      extracoinStatement: canViewFeature("extracoinStatement"),
      extrabonusStatement: canViewFeature("extrabonusStatement"),
      bonusStatement: canViewFeature("bonusStatement"),
      dropshipping: canViewFeature("dropshipping"),
      coupons: canViewFeature("coupons"),
      products: canViewFeature("products"),
      attributes: canViewFeature("attributes"),
      sales: canViewFeature("sales"),
      purchases: canViewFeature("purchases"),
      extracoinTransfer: canViewFeature("extracoinTransfer"),
      extracoinIntents: canViewFeature("extracoinIntents"),
      withdrawIntent: canViewFeature("withdrawIntent"),
      extrapay: canViewFeature("extrapay"),
      userStore: canViewFeature("userStore"),
      favorites: canViewFeature("favorites"),
      importProducts: canViewFeature("importProducts"),
      renewSubscription: canViewFeature("renewSubscription"),
      web3Dashboard: canViewFeature("web3Dashboard"),
      storesMap: canViewFeature("storesMap"),
      fringeBenefit: canViewFeature("fringeBenefit"),
      evaluationButton: canViewFeature("evaluationButton"),
      createProducts: canViewFeature("createProducts"),
      publishProducts: canViewFeature("publishProducts"),
      storeUpgradeRequired: canViewFeature("storeUpgradeRequired"),
    };
  };

  return {
    isManager,
    isPartner,
    isSeller,
    isStore,
    isCustomer,
    isPromoter,
    hasSubscription,
    canViewStorePanel,
    canManageProducts,
    storeSalesEnabled,
    canViewFeature,
    getAvailableFeatures,
  };
};

export default useDashboardPermissions;
